module.exports = __webpack_public_path__ + "static/media/step2_es.970db8c2.png";